/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { css } from '@emotion/react';
import Slider from 'react-slick';

import HeroT5 from './oc-hero-tier-5';
import RichText from './oc-rich-text';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const arrowStyles = css`
  font-size: 32px;
  font-weight: bolder;
  position: absolute;
  top: 50%;
  transform: translateY(-16px);
  color: white;
  z-index: 10;
  cursor: pointer;
  text-shadow: 0 -1px 10px rgba(0, 0, 0, 0.4);
`;
const nextArrowStyles = css`
  ${arrowStyles};
  right: 32px;

  @media (max-width: 1199px) {
    right: 16px;
  }

  @media (max-width: 767px) {
    right: 8px;
  }
`;
const prevArrowStyles = css`
  ${arrowStyles};
  left: 32px;

  @media (max-width: 1199px) {
    left: 16px;
  }

  @media (max-width: 767px) {
    left: 8px;
  }
`;

const NextArrow = ({ onClick }) => <span className="icon-chevron-right" css={nextArrowStyles} onClick={onClick} />;
const PrevArrow = ({ onClick }) => <span className="icon-chevron-left" css={prevArrowStyles} onClick={onClick} />;

const HeroTier5Carousel = ({ carouselItems }) => (
  <Slider
    dots
    dotsClass="hero-slick-dots"
    swipe={false}
    draggable={false}
    fade
    infinite
    speed={500}
    waitForAnimate={false}
    adaptiveHeight
    autoplay
    autoplaySpeed={4000}
    pauseOnHover={false}
    nextArrow={<NextArrow />}
    prevArrow={<PrevArrow />}
  >
    {carouselItems.map(item => (
      <HeroT5
        imgDesktop={item.image}
        imgTablet={item.image}
        imgMobile={item.image}
        videoMp4={item.mp4}
        videoWebm={item.webm}
        mediaType={item.mediaType}
        h1={<RichText content={item.heading} inline />}
        posthead={item.posthead}
        ctas={item.ctaList}
      />
    ))}
  </Slider>
);

export default HeroTier5Carousel;
